/**
 * @generated SignedSource<<98f316ba4ae7148661030150b52e90f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AccountType = "CHAIN" | "INDIVIDUAL" | "%future added value";
export type ConnectionStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type JobTypes = "INSTALLATION" | "INSTALLATION_FOLLOW_UP" | "SAMPLE_EVENT" | "SITE_VISIT" | "%future added value";
export type Priority = "HIGH" | "HIGHEST" | "LOW" | "MEDIUM" | "%future added value";
export type ServiceType = "ON_SITE" | "REMOTE" | "%future added value";
export type Status = "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type Statuses = "ARCHIVED" | "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "SYSTEM_CLOSED" | "SYSTEM_OPEN" | "%future added value";
export type TicketType = "LAB" | "MARKETING_OTHER" | "PREVENTIVE_MAINTANANCE" | "REACTIVE_MAINTANANCE" | "%future added value";
export type TypeOfContactPhoneNumbers = "OFFICE" | "PERSONAL" | "%future added value";
export type WorkOrderStatusEnum = "COMPLETED" | "PENDING" | "%future added value";
export type LocationHistory_getLocationQuery$variables = {
  id: string;
};
export type LocationHistory_getLocationQuery$data = {
  readonly getLocation: {
    readonly address: string;
    readonly applicableTax: number | null;
    readonly businessHours: ReadonlyArray<{
      readonly closeTime: string | null;
      readonly createdAt: any | null;
      readonly dayOfWeek: number;
      readonly id: string;
      readonly isOpen: boolean | null;
      readonly locationId: string;
      readonly openTime: string | null;
      readonly updatedAt: any | null;
    }> | null;
    readonly businessModel: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly businessModelId: string | null;
    readonly city: string | null;
    readonly contactEmail: string | null;
    readonly contactName: string | null;
    readonly contactPhone: string | null;
    readonly contractOwner: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly contractOwnerId: string | null;
    readonly createdAt: any | null;
    readonly createdBy: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
    readonly customer: {
      readonly accountType: AccountType | null;
      readonly customerCompanyName: string | null;
      readonly customerContactEmail: string | null;
      readonly customerContactName: string | null;
      readonly customerContactNameRole: string | null;
      readonly customerContactPhoneNumber: string | null;
      readonly customerSecondContact: boolean | null;
      readonly customerSecondContactEmail: string | null;
      readonly customerSecondContactName: string | null;
      readonly customerSecondContactNameRole: string | null;
      readonly customerSecondContactPhoneNumber: string | null;
      readonly distributorId: string | null;
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string;
      readonly uuid: string | null;
    } | null;
    readonly customerId: string;
    readonly customerItContact: boolean | null;
    readonly customerMarketingContact: boolean;
    readonly customerSecondContact: boolean;
    readonly customerServiceContact: boolean;
    readonly deploymentManager: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly deploymentManagerId: string | null;
    readonly distributor: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly distributorId: string | null;
    readonly filterProvider: {
      readonly id: string;
      readonly title: string;
    } | null;
    readonly flavorPrices: ReadonlyArray<{
      readonly flavor: string;
      readonly price: number;
    }> | null;
    readonly freezerCredentials: {
      readonly apiKey: string;
      readonly serialNumber: string;
    } | null;
    readonly gasSupplier: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly gasSupplierId: string | null;
    readonly hasPressurePump: boolean | null;
    readonly hasPressureTank: boolean | null;
    readonly hasSmoodiRouter: boolean | null;
    readonly hasWifiExtender: boolean | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly itContactEmail: string | null;
    readonly itContactName: string | null;
    readonly itContactNameRole: string | null;
    readonly itContactPhoneNumber: string | null;
    readonly latitude: string | null;
    readonly launchDate: string | null;
    readonly locationType: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly locationTypeId: string | null;
    readonly logJobs: ReadonlyArray<{
      readonly additionalComments: string | null;
      readonly closingDateAndTime: string | null;
      readonly createdAt: any;
      readonly createdBy: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly dateAndTime: string;
      readonly id: string;
      readonly jobType: JobTypes;
      readonly location: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly locationId: string;
      readonly machineName: string | null;
      readonly machineSerialNumber: string | null;
      readonly status: Status;
      readonly uuid: string | null;
    }> | null;
    readonly longitude: string | null;
    readonly machineCount: number | null;
    readonly machines: ReadonlyArray<{
      readonly connectionStatus: ConnectionStatus | null;
      readonly createdAt: any | null;
      readonly createdBy: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly deployingPerson: {
        readonly firstName: string;
        readonly id: string;
      } | null;
      readonly deploymentDate: string;
      readonly hardwareVersion: string | null;
      readonly id: string;
      readonly isActive: boolean;
      readonly isRetired: boolean;
      readonly machineStatus: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly name: string | null;
      readonly remark: string | null;
      readonly retiredAt: any | null;
      readonly retiredBy: {
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string | null;
      } | null;
      readonly retiredById: string | null;
      readonly serialNumber: string;
      readonly softwareVersion: string | null;
      readonly tickets: ReadonlyArray<{
        readonly assignTo: {
          readonly firstName: string;
          readonly id: string;
        } | null;
        readonly blender: {
          readonly id: string;
          readonly title: string;
          readonly versionNo: string;
        } | null;
        readonly blenderId: string | null;
        readonly board: {
          readonly id: string;
          readonly title: string;
          readonly versionNo: string;
        } | null;
        readonly boardId: string | null;
        readonly closingDateAndTime: string | null;
        readonly comment: string | null;
        readonly createdBy: {
          readonly firstName: string;
          readonly id: string;
        } | null;
        readonly diagnosisDone: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly diagnosisOtherInput: string | null;
        readonly id: string;
        readonly isFilterReplaced: boolean | null;
        readonly isSanitizerReplaced: boolean | null;
        readonly issueReportedOtherInput: string | null;
        readonly issuesReported: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly location: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly machine: {
          readonly id: string;
          readonly name: string | null;
          readonly serialNumber: string;
        } | null;
        readonly machineServiceOtherInput: string | null;
        readonly machineServices: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly machineServicesDone: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly media: ReadonlyArray<{
          readonly type: string | null;
          readonly url: string | null;
        }> | null;
        readonly operationOtherInput: string | null;
        readonly operations: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly operationsDone: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly priority: Priority;
        readonly reportedAt: string | null;
        readonly serviceType: ServiceType | null;
        readonly status: Statuses;
        readonly ticketSource: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly ticketType: TicketType | null;
        readonly uuid: string | null;
        readonly workStartTime: any | null;
      }> | null;
      readonly updatedAt: any | null;
      readonly uuid: string | null;
    }> | null;
    readonly marketSegment: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly marketSegmentId: string | null;
    readonly marketingContactEmail: string | null;
    readonly marketingContactName: string | null;
    readonly marketingContactNameRole: string | null;
    readonly marketingContactPhoneNumber: string | null;
    readonly name: string;
    readonly noOfBlenders: number | null;
    readonly noOfFreezers: number | null;
    readonly region: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly regionId: string | null;
    readonly salesLeadId: string | null;
    readonly salesSupport1Id: string | null;
    readonly salesSupport2Id: string | null;
    readonly salesSupport2Persentage: number | null;
    readonly samplingRecommendedDays: number | null;
    readonly samplingRecommendedTime: string | null;
    readonly secondContactEmail: string | null;
    readonly secondContactName: string | null;
    readonly secondContactNameRole: string | null;
    readonly secondContactPhoneNumber: string | null;
    readonly serviceContactEmail: string | null;
    readonly serviceContactName: string | null;
    readonly serviceContactNameRole: string | null;
    readonly serviceContactPhoneNumber: string | null;
    readonly servicePlan: {
      readonly createdAt: any | null;
      readonly id: string;
      readonly indicater: string | null;
      readonly name: string;
    } | null;
    readonly servicePlanId: string | null;
    readonly state: string | null;
    readonly storeManagerContact: boolean;
    readonly storeManagerContactEmail: string | null;
    readonly storeManagerContactName: string | null;
    readonly storeManagerContactPhoneNumber: string | null;
    readonly targetLaunchDate: string | null;
    readonly typeOfContactPhoneNumber: TypeOfContactPhoneNumbers;
    readonly typeOfItContactPhoneNumber: TypeOfContactPhoneNumbers | null;
    readonly typeOfMarketingContactPhoneNumber: TypeOfContactPhoneNumbers | null;
    readonly typeOfSecondContactPhoneNumber: TypeOfContactPhoneNumbers | null;
    readonly typeOfServiceContactPhoneNumber: TypeOfContactPhoneNumbers | null;
    readonly typeOfStoreManagerContactPhoneNumber: TypeOfContactPhoneNumbers | null;
    readonly updatedAt: any | null;
    readonly uuid: string | null;
    readonly warrantyExpireAt: string | null;
    readonly waterPressure: number | null;
    readonly wifiCredentials: {
      readonly name: string | null;
      readonly password: string | null;
    } | null;
    readonly wifiSignalStrength: string | null;
    readonly workOrders: ReadonlyArray<{
      readonly comment: string | null;
      readonly date: any | null;
      readonly deploymentManagerId: string | null;
      readonly firstName: string | null;
      readonly id: string;
      readonly installerId: string | null;
      readonly installerName: string | null;
      readonly lastName: string | null;
      readonly status: WorkOrderStatusEnum | null;
    }> | null;
    readonly zipCode: string | null;
  };
};
export type LocationHistory_getLocationQuery = {
  response: LocationHistory_getLocationQuery$data;
  variables: LocationHistory_getLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deploymentManagerId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distributorId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerSecondContact",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serialNumber",
  "storageKey": null
},
v16 = [
  (v1/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v18 = [
  (v1/*: any*/),
  (v13/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "UserObjectType",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingDateAndTime",
  "storageKey": null
},
v22 = [
  (v1/*: any*/),
  (v17/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "versionNo",
    "storageKey": null
  }
],
v23 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocation",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicableTax",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ContractOwnerObjectType",
        "kind": "LinkedField",
        "name": "contractOwner",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contractOwnerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "warrantyExpireAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesLeadId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesSupport1Id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesSupport2Id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesSupport2Persentage",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "regionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gasSupplierId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasSmoodiRouter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasWifiExtender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPressurePump",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPressureTank",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactPhone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "latitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "longitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zipCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "waterPressure",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketSegmentId",
        "storageKey": null
      },
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "businessModelId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationTypeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetLaunchDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "launchDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noOfBlenders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noOfFreezers",
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "samplingRecommendedTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "samplingRecommendedDays",
        "storageKey": null
      },
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "machineCount",
        "storageKey": null
      },
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secondContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secondContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secondContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secondContactNameRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerMarketingContact",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingContactNameRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerItContact",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "itContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "itContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "itContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "itContactNameRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerServiceContact",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceContactNameRole",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfMarketingContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfSecondContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfItContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfServiceContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storeManagerContact",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storeManagerContactName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storeManagerContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storeManagerContactEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeOfStoreManagerContactPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkOrderObjectType",
        "kind": "LinkedField",
        "name": "workOrders",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "installerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "installerName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GasSupplierObjectType",
        "kind": "LinkedField",
        "name": "gasSupplier",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WifiCredentialsObjectType",
        "kind": "LinkedField",
        "name": "wifiCredentials",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "password",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationFreezerDetailObjectType",
        "kind": "LinkedField",
        "name": "freezerCredentials",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "apiKey",
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wifiSignalStrength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BusinessModelsObjectType",
        "kind": "LinkedField",
        "name": "businessModel",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DistributorObjectType",
        "kind": "LinkedField",
        "name": "distributor",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": (v16/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketSegmentObjectType",
        "kind": "LinkedField",
        "name": "marketSegment",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FilterProviderObjectType",
        "kind": "LinkedField",
        "name": "filterProvider",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "deploymentManager",
        "plural": false,
        "selections": (v18/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationTypeObjectType",
        "kind": "LinkedField",
        "name": "locationType",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RegionObjectType",
        "kind": "LinkedField",
        "name": "region",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerObjectType",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerCompanyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerContactName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerContactPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerContactEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerContactNameRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          },
          (v6/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerSecondContactName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerSecondContactPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerSecondContactEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerSecondContactNameRole",
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationFlavorPricesObjectType",
        "kind": "LinkedField",
        "name": "flavorPrices",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flavor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LogJobsObjectType",
        "kind": "LinkedField",
        "name": "logJobs",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobType",
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationObjectType",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateAndTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machineSerialNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machineName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalComments",
            "storageKey": null
          },
          (v20/*: any*/),
          (v7/*: any*/),
          (v12/*: any*/),
          (v21/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MachineObjectType",
        "kind": "LinkedField",
        "name": "machines",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v15/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deploymentDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "softwareVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hardwareVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "connectionStatus",
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remark",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retiredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retiredById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRetired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserObjectType",
            "kind": "LinkedField",
            "name": "retiredBy",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserObjectType",
            "kind": "LinkedField",
            "name": "deployingPerson",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MachineStatusObjectType",
            "kind": "LinkedField",
            "name": "machineStatus",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketObjectType",
            "kind": "LinkedField",
            "name": "tickets",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LocationObjectType",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MachineObjectType",
                "kind": "LinkedField",
                "name": "machine",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaDto",
                "kind": "LinkedField",
                "name": "media",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFilterReplaced",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSanitizerReplaced",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workStartTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ticketType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceType",
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "machineServiceOtherInput",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "operationOtherInput",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "issueReportedOtherInput",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisOtherInput",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OperationObjectType",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MachineServiceObjectType",
                "kind": "LinkedField",
                "name": "machineServicesDone",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MachineServiceObjectType",
                "kind": "LinkedField",
                "name": "machineServices",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OperationObjectType",
                "kind": "LinkedField",
                "name": "operationsDone",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueReportedObjectType",
                "kind": "LinkedField",
                "name": "issuesReported",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DiagnosisObjectType",
                "kind": "LinkedField",
                "name": "diagnosisDone",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "boardId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BoardObjectType",
                "kind": "LinkedField",
                "name": "board",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blenderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BlenderObjectType",
                "kind": "LinkedField",
                "name": "blender",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TicketSourceObjectType",
                "kind": "LinkedField",
                "name": "ticketSource",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reportedAt",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserObjectType",
                "kind": "LinkedField",
                "name": "assignTo",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationBusinessHourObjectType",
        "kind": "LinkedField",
        "name": "businessHours",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOfWeek",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closeTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOpen",
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "servicePlanId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ServicePlanObjectType",
        "kind": "LinkedField",
        "name": "servicePlan",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "indicater",
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LocationHistory_getLocationQuery",
    "selections": (v23/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LocationHistory_getLocationQuery",
    "selections": (v23/*: any*/)
  },
  "params": {
    "cacheID": "5061b215a5d6f86731c7a46517ad2607",
    "id": null,
    "metadata": {},
    "name": "LocationHistory_getLocationQuery",
    "operationKind": "query",
    "text": "query LocationHistory_getLocationQuery(\n  $id: String!\n) {\n  getLocation(id: $id) {\n    id\n    uuid\n    applicableTax\n    contractOwner {\n      id\n      name\n    }\n    contractOwnerId\n    warrantyExpireAt\n    customerId\n    salesLeadId\n    salesSupport1Id\n    salesSupport2Id\n    salesSupport2Persentage\n    name\n    address\n    regionId\n    gasSupplierId\n    hasSmoodiRouter\n    hasWifiExtender\n    hasPressurePump\n    hasPressureTank\n    contactName\n    contactPhone\n    contactEmail\n    latitude\n    longitude\n    zipCode\n    state\n    city\n    waterPressure\n    marketSegmentId\n    deploymentManagerId\n    businessModelId\n    locationTypeId\n    targetLaunchDate\n    launchDate\n    noOfBlenders\n    noOfFreezers\n    distributorId\n    samplingRecommendedTime\n    samplingRecommendedDays\n    createdAt\n    updatedAt\n    isActive\n    machineCount\n    customerSecondContact\n    secondContactName\n    secondContactPhoneNumber\n    secondContactEmail\n    secondContactNameRole\n    customerMarketingContact\n    marketingContactName\n    marketingContactPhoneNumber\n    marketingContactEmail\n    marketingContactNameRole\n    customerItContact\n    itContactName\n    itContactPhoneNumber\n    itContactEmail\n    itContactNameRole\n    customerServiceContact\n    serviceContactName\n    serviceContactPhoneNumber\n    serviceContactEmail\n    serviceContactNameRole\n    typeOfContactPhoneNumber\n    typeOfMarketingContactPhoneNumber\n    typeOfSecondContactPhoneNumber\n    typeOfItContactPhoneNumber\n    typeOfServiceContactPhoneNumber\n    storeManagerContact\n    storeManagerContactName\n    storeManagerContactPhoneNumber\n    storeManagerContactEmail\n    typeOfStoreManagerContactPhoneNumber\n    workOrders {\n      id\n      deploymentManagerId\n      comment\n      status\n      firstName\n      lastName\n      date\n      installerId\n      installerName\n    }\n    gasSupplier {\n      id\n      name\n    }\n    wifiCredentials {\n      name\n      password\n    }\n    freezerCredentials {\n      apiKey\n      serialNumber\n    }\n    wifiSignalStrength\n    businessModel {\n      id\n      name\n    }\n    distributor {\n      id\n      name\n    }\n    createdBy {\n      id\n      firstName\n      lastName\n    }\n    marketSegment {\n      id\n      name\n    }\n    filterProvider {\n      id\n      title\n    }\n    deploymentManager {\n      id\n      firstName\n    }\n    locationType {\n      id\n      name\n    }\n    region {\n      id\n      name\n    }\n    customer {\n      id\n      name\n      uuid\n      customerCompanyName\n      customerContactName\n      customerContactPhoneNumber\n      customerContactEmail\n      customerContactNameRole\n      accountType\n      distributorId\n      customerSecondContact\n      customerSecondContactName\n      customerSecondContactPhoneNumber\n      customerSecondContactEmail\n      customerSecondContactNameRole\n      isActive\n    }\n    flavorPrices {\n      flavor\n      price\n    }\n    logJobs {\n      id\n      uuid\n      jobType\n      locationId\n      location {\n        id\n        name\n      }\n      dateAndTime\n      machineSerialNumber\n      machineName\n      additionalComments\n      createdBy {\n        id\n        firstName\n      }\n      createdAt\n      status\n      closingDateAndTime\n    }\n    machines {\n      id\n      uuid\n      serialNumber\n      name\n      deploymentDate\n      softwareVersion\n      hardwareVersion\n      connectionStatus\n      createdAt\n      updatedAt\n      isActive\n      remark\n      retiredAt\n      retiredById\n      isRetired\n      retiredBy {\n        id\n        firstName\n        lastName\n      }\n      createdBy {\n        id\n        firstName\n      }\n      deployingPerson {\n        id\n        firstName\n      }\n      machineStatus {\n        id\n        name\n      }\n      tickets {\n        id\n        uuid\n        location {\n          name\n          id\n        }\n        machine {\n          id\n          name\n          serialNumber\n        }\n        media {\n          type\n          url\n        }\n        isFilterReplaced\n        isSanitizerReplaced\n        workStartTime\n        ticketType\n        serviceType\n        comment\n        machineServiceOtherInput\n        operationOtherInput\n        issueReportedOtherInput\n        diagnosisOtherInput\n        operations {\n          id\n          name\n        }\n        machineServicesDone {\n          id\n          name\n        }\n        machineServices {\n          id\n          name\n        }\n        operationsDone {\n          id\n          name\n        }\n        issuesReported {\n          id\n          name\n        }\n        diagnosisDone {\n          id\n          name\n        }\n        boardId\n        board {\n          id\n          title\n          versionNo\n        }\n        blenderId\n        blender {\n          id\n          title\n          versionNo\n        }\n        priority\n        ticketSource {\n          id\n          name\n        }\n        createdBy {\n          id\n          firstName\n        }\n        reportedAt\n        closingDateAndTime\n        assignTo {\n          id\n          firstName\n        }\n        status\n      }\n    }\n    businessHours {\n      id\n      locationId\n      dayOfWeek\n      openTime\n      closeTime\n      isOpen\n      createdAt\n      updatedAt\n    }\n    servicePlanId\n    servicePlan {\n      id\n      name\n      indicater\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b6b0ffd6259388611f0228d52b55160";

export default node;
